import { t } from 'helpers/i18n';
import { IType } from './implement';

export enum EMerchantStatus {
  CREATED = 'Khởi tạo',
  ACTIVATED = 'KD duyệt',
  LOCKED = 'Khóa',
  WAITING_FOR_APPROVE = 'KD chờ duyệt',
  NEED_UPDATE_DOCUMENT = 'Bổ sung HS',
  REJECTED = 'Từ chối',
  POTENTIAL = 'Tiềm năng',
  PROVIDER_CREATED = 'ĐVPT khởi tạo',
}

const MERCHANT_STATUS: { [key: string]: any } = {
  [EMerchantStatus.CREATED]: {
    text: 'Khởi tạo',
    code: EMerchantStatus.CREATED,
    color: '#cc8733',
  },
  [EMerchantStatus.ACTIVATED]: {
    text: 'Hoạt động',
    code: EMerchantStatus.ACTIVATED,
    color: '#1990FF',
  },
  [EMerchantStatus.WAITING_FOR_APPROVE]: {
    text: 'KD chờ duyệt',
    code: EMerchantStatus.WAITING_FOR_APPROVE,
    color: '#26a44d',
  },
  [EMerchantStatus.NEED_UPDATE_DOCUMENT]: {
    text: 'Bổ sung HS',
    code: EMerchantStatus.NEED_UPDATE_DOCUMENT,
    color: '#ca9de6',
  },
  [EMerchantStatus.REJECTED]: {
    text: 'Từ chối',
    code: EMerchantStatus.REJECTED,
    color: '#bcbfd6',
  },
  [EMerchantStatus.POTENTIAL]: {
    text: 'Tiềm năng',
    code: EMerchantStatus.POTENTIAL,
    color: '#FFCC5C',
  },
  [EMerchantStatus.PROVIDER_CREATED]: {
    text: 'ĐVPT khởi tạo',
    code: EMerchantStatus.PROVIDER_CREATED,
    color: '#CA9DE6',
  },
};
export const STEP = {
  STEP1: '1',
  STEP2: '2',
  STEP3: '3',
  STEP4: '4',
};

const CAN_ADD_BENEFICIARY_STATUS = [
  EMerchantStatus.CREATED.toString(),
  EMerchantStatus.ACTIVATED.toString(),
];

const APPROACHING_STATUS: IType = {
  ALL: {
    value: 0,
    label: t('All'),
  },
  SEARCH: {
    value: 1,
    label: t('AgreeSign'),
  },
  CONSIDER: {
    value: 2,
    label: t('AgreeNotSign'),
  },
  APPROVENOTSIGN: {
    value: 3,
    label: t('Consider'),
  },
  APPROVESIGN: {
    value: 4,
    label: t('Search'),
  },
  IMPLEMENT_QR: {
    value: 5,
    label: t('ImplementQR'),
  },
  COMPLETE_1LAST: {
    value: 6,
    label: t('Complete1Last'),
  },
  STOP_APPOARCH: {
    value: 7,
    label: t('StopApproaching'),
  },
};

const MERCHANT_TYPE = {
  COMPANY: 'Công ty',
  INDIVIDUAL: 'Cá nhân',
  HOUSE_BUSINESS: 'Hộ kinh doanh',
  ENTERPRISE: 'Doanh nghiệp',
};

const VIEW_MODE = 'view';
const VN_CODE = 'VN';

export default {
  EMerchantStatus,
  MERCHANT_STATUS,
  CAN_ADD_BENEFICIARY_STATUS,
  STEP,
  LOAD_MORE_MERCHANT_MAX: 50,
  APPROACHING_STATUS,
  MERCHANT_TYPE,
  VIEW_MODE,
  VN_CODE,
};
